import { IAppState } from '../../../AppModulesWrapper';

import { ECheckServiceStatus } from '../../types/reducers/checkoutInfo';
import { EPublishOfferStatus } from '../../types/reducers/publishInfo';

export function selectIsPublishButtonPending(state: IAppState): boolean {
  const { checkoutInfo, publishInfo } = state.servicePickerWidget;

  return checkoutInfo.status === ECheckServiceStatus.pending || publishInfo.status === EPublishOfferStatus.pending;
}
